import "@/App.css";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Intro } from "@/components/site/Intro";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { Prices } from "@/components/site/Prices";
import { Gallery } from "@/components/site/Gallery";
import { Team } from "@/components/site/Team";
import { Bride } from "@/components/site/Bride";
import { Booking } from "@/components/site/Booking";
import { Contacts } from "@/components/site/Contacts";
import { Footer } from "@/components/site/Footer";

function App() {
  return (
    <div className="App grain overflow-x-clip max-w-[100vw]">
      <SmoothScroll />
      <Intro />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Bride />
        <Prices />
        <Gallery />
        {/* <Team /> — nascosta finché non arrivano le foto reali del team. Riabilita rimuovendo i commenti qui e in data.js NAV. */}
        <Booking />
        <Contacts />
      </main>
      <Footer />
      <Toaster position="bottom-center" theme="dark" toastOptions={{ style: { background: "#141417", border: "1px solid rgba(217,180,90,.35)", color: "#F7F5F0" } }} />
    </div>
  );
}

export default App;
